import { useMemo } from "react";
import RadioList from "@/components/common/list/radioList";
import { Provider } from "../providerSection";

export const SelectServiceProviderForm = ({
  availableProviders,
  selectedProviderId,
  onSelect,
}: {
  availableProviders: Provider[];
  selectedProviderId: string;
  onSelect: (providerId: string) => void;
}) => {
  const items = useMemo(
    () =>
      availableProviders.map((provider) => ({
        id: provider.id,
        label: provider.user.fullName,
        isChecked: provider.id === selectedProviderId,
        onChange: () => onSelect(provider.id),
      })),
    [availableProviders, onSelect, selectedProviderId]
  );

  return (
    <RadioList
      sx={{ pt: 0, maxHeight: "calc(90dvh - 240px)", overflow: "auto" }}
      items={items}
      withDivider
    />
  );
};
